const getContract = () => JSON.parse(localStorage.getItem('contract')) ?? {};
const saveContract = (contract) => localStorage.setItem('contract', JSON.stringify(contract));
const clearContract = () => localStorage.removeItem('contract');

const getSource = () => JSON.parse(localStorage.getItem('source')) ?? {};
const saveSource = (contract) => localStorage.setItem('source', JSON.stringify(contract));
const clearSource = () => localStorage.removeItem('source');
export const storageService = {
  getContract,
  saveContract,
  clearContract,
  getSource,
  saveSource,
  clearSource,
};
